module.exports = __webpack_public_path__ + "img/avatar2.9b28279c.png";